"use strict";
var root_1 = require('../util/root');
var Symbol = root_1.root.Symbol;
exports.rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function') ?
    Symbol.for('rxSubscriber') : '@@rxSubscriber';
/**
 * @deprecated use rxSubscriber instead
 */
exports.$$rxSubscriber = exports.rxSubscriber;
//# sourceMappingURL=rxSubscriber.js.map


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/rxjs/symbol/rxSubscriber.js
// module id = ../../../../rxjs/symbol/rxSubscriber.js
// module chunks = 37